const categories = {
  slug: 'categories',
  getCategories: () => `${categories.slug}`,
  vote: () => `${categories.slug}/vote`
}

export default categories
